import React from 'react';
import { Button, ScrollView, StyleSheet, Text, View } from 'react-native';
import { useDispatch } from 'react-redux';
import { useGetMeQuery } from '../services/abbiWayApi';
import { signout } from '../redux/appSlice';
import Footer from './Footer';
import { SigninView } from './SigninView';
import { UserInfo } from './UserInfo';
import { theme } from '../theme';
/** Desktop side panel width. */
export const SIDE_PANEL_WIDTH = 300;
const SIDE_PANEL_BACKGROUND_COLOR = theme.colors.sidePanelBackground;
export const SidePanel = ({ onAddClientPress, onGenerateProgramPress, fullWidth = false, }) => {
    const { data: me } = useGetMeQuery();
    const dispatch = useDispatch();
    const signoutPress = () => {
        dispatch(signout());
    };
    return (<View style={[styles.sidebar, fullWidth && styles.sidebarFullWidth]}>
      {!me ? (<View style={styles.container}>
          <Text style={styles.prompt}>Sign in:</Text>
          <View style={styles.signinView}>
            <SigninView />
          </View>
        </View>) : (
        // Scrolls when the window is short so the footer (Signout) never overlaps the lists.
        <ScrollView style={styles.scrollArea} contentContainerStyle={styles.scrollContent}>
          <UserInfo user={me} onAddClientPress={onAddClientPress} onGenerateProgramPress={onGenerateProgramPress}/>
        </ScrollView>)}
      <View style={styles.footerArea}>
        {me ? <Button title="Signout" onPress={signoutPress}/> : null}
        {/* Admin CRM: no Privacy / deletion footer — clients and guests still see it. */}
        {me?.role?.name === 'Admin' ? null : <Footer />}
      </View>
    </View>);
};
const styles = StyleSheet.create({
    sidebar: {
        flexShrink: 0,
        flexDirection: 'column',
        width: SIDE_PANEL_WIDTH,
        backgroundColor: SIDE_PANEL_BACKGROUND_COLOR,
        justifyContent: 'space-between', // keeps Footer pinned
    },
    sidebarFullWidth: {
        width: '100%',
        flexGrow: 1,
    },
    scrollContainer: {
        flex: 1,
    },
    scrollArea: {
        flex: 1,
        minHeight: 0,
    },
    scrollContent: {
        flexGrow: 1,
        marginLeft: 16,
        marginRight: 16,
    },
    container: {
        flexShrink: 1,
        marginLeft: 16,
        marginRight: 16,
        flex: 1,
    },
    footerArea: {
        flexShrink: 0,
        marginTop: 24,
        marginLeft: 16,
        marginRight: 16,
        paddingBottom: 12,
    },
    signinView: {
        alignItems: 'stretch',
        marginTop: 8,
        paddingRight: 8,
    },
    prompt: {
        color: theme.colors.surfaceElevated,
        fontSize: 24,
        marginTop: 20,
        marginLeft: 0,
        marginBottom: 16,
    },
});
